import React, { useCallback } from 'react';

import { useStepHook } from '../logic/useStepHook';
import { StepView } from './StepView';
import { useVerifySsnCardMutation } from '../logic/useVerifySsnCardMutation';
import { WizardFlowActionType } from '../logic/WizardContext';
import { VerifyEmailAnswerReturn } from '../logic/useVerifyEmailCodeMutation';
import { ApiError } from '../ChangePhone';
import { ReactComponent as Last4Card } from '../../../assets/svg/last-four-card.svg';

export const CardStep = () => {
  const { dispatch, data, email, t, handleErrorCode } = useStepHook();

  const handleSuccessVerify = useCallback((apiData: VerifyEmailAnswerReturn) => {
    dispatch({ type: WizardFlowActionType.NEXT_STEP });
    dispatch({
      type: WizardFlowActionType.SET_DATA,
      payload: { apiResponseData: apiData?.newPhoneNumberResponseCustomData?.stateToken },
    });
  }, []);

  const onError = useCallback((error: ApiError) => {
    handleErrorCode(error);
  }, []);

  const { isLoading, mutate: mutateVerify } = useVerifySsnCardMutation(handleSuccessVerify, onError);

  const handleCardFulfil = useCallback(
    (value: string) => {
      dispatch({ type: WizardFlowActionType.SET_DATA, payload: { lastFourCard: value } });
      if (data?.lastFourSSN) {
        mutateVerify({ email, cardLastFourDigits: value, ssn: data.lastFourSSN });
      }
    },
    [dispatch, data],
  );

  return (
    <StepView
      title={t('CHANGE_PHONE.CARD.TITLE')}
      headLineSmallText={t('CHANGE_PHONE.CARD.SUB_HEADER')}
      buttonTitle={t('CHANGE_PHONE.BUTTON_TITLE')}
      handleClick={handleCardFulfil}
      isLoading={isLoading}
      numOfDigits={4}
      svg={Last4Card}
    />
  );
};
